

import { Home } from 'lucide-react';
import ErrorBoundary from '../ErrorBoundary';

interface StationImageProps {
  imageUrl?: string;
  aiGeneratedImage?: string;
  title: string;
  isHomeCharger?: boolean;
}

const StationImage = ({ imageUrl, aiGeneratedImage, title, isHomeCharger }: StationImageProps) => {
  if (!title) {
    throw new Error('Station title is required');
  }

  // Prioritize AI-generated image if available
  const displayImage = aiGeneratedImage || imageUrl || '/placeholder.svg';

  return (
    <ErrorBoundary>
      <div className="relative h-64 md:h-96 rounded-lg overflow-hidden">
        <img 
          src={displayImage} 
          alt={title} 
          className="object-cover w-full h-full"
        />
        {aiGeneratedImage && (
          <div className="absolute top-0 left-0 bg-blue-500 text-white px-3 py-1 m-4 rounded-md flex items-center">
            <span>AI Generated</span>
          </div>
        )}
        {isHomeCharger && (
          <div className="absolute top-0 right-0 bg-blue-500 text-white px-3 py-1 m-4 rounded-md flex items-center">
            <Home className="h-4 w-4 mr-1" />
            <span>Home Charger</span>
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};

export default StationImage;
